import { Link } from "react-router-dom";
import { LOGO_URL } from "../../lib/api";

/**
 * AuthShell — luxury, minimal container used by all auth pages.
 * Fully responsive: stacked, full-width buttons on mobile.
 */
export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-[#FAF9F7] flex flex-col" data-testid="auth-shell">
      <header className="py-8 px-6">
        <Link to="/" className="block w-fit mx-auto" data-testid="auth-logo-link">
          <img src={LOGO_URL} alt="Prize Joias" className="h-8 w-auto" />
        </Link>
      </header>
      <main className="flex-1 flex items-start justify-center px-6 pb-16">
        <div className="w-full max-w-md bg-white border border-[#E8E4DF] p-8 sm:p-12">
          <div className="text-center mb-10">
            <h1 className="font-display text-3xl sm:text-4xl text-[#1A1A1A] leading-tight" data-testid="auth-title">{title}</h1>
            {subtitle && <p className="text-sm text-[#6B6B6B] mt-3" data-testid="auth-subtitle">{subtitle}</p>}
          </div>
          {children}
          {footer && (
            <div className="border-t border-[#E8E4DF] mt-10 pt-6 text-center text-sm text-[#6B6B6B]" data-testid="auth-footer">
              {footer}
            </div>
          )}
        </div>
      </main>
      <style>{`
        .auth-label { display:block; font-family: 'Jost', sans-serif; font-size:10px; letter-spacing:0.25em; text-transform:uppercase; color:#A8A8A8; margin-bottom:8px; }
        .auth-input { width:100%; border:1px solid #E8E4DF; background:#FFFFFF; padding:12px 14px; font-family:'Jost', sans-serif; font-size:14px; color:#1A1A1A; outline:none; transition: border-color .15s; }
        .auth-input:focus { border-color:#B8A88A; }
        .auth-input.error { border-color:#B85050; }
        .auth-cta { display:inline-flex; align-items:center; justify-content:center; gap:8px; width:100%; background:#B8A88A; color:#FFFFFF; font-family:'Jost', sans-serif; font-size:11px; letter-spacing:0.2em; text-transform:uppercase; padding:14px 16px; border:none; cursor:pointer; transition: background .15s; }
        .auth-cta:hover { background:#8C7B5E; }
        .auth-cta:disabled { background:#D4CCBE; cursor:not-allowed; }
        .auth-cta-secondary { background:#FFFFFF; color:#1A1A1A; border:1px solid #1A1A1A; }
        .auth-cta-secondary:hover { background:#1A1A1A; color:#FFFFFF; }
        .auth-link { color:#B8A88A; text-decoration:none; }
        .auth-link:hover { color:#8C7B5E; text-decoration:underline; }
        .auth-divider { display:flex; align-items:center; gap:14px; margin:24px 0; font-family:'Jost', sans-serif; font-size:10px; letter-spacing:0.2em; text-transform:uppercase; color:#A8A8A8; }
        .auth-divider::before, .auth-divider::after { content:''; flex:1; height:1px; background:#E8E4DF; }
      `}</style>
    </div>
  );
}
